import styles from './Account.module.css';
import { formatDate } from '../../services/billingService';

/**
 * Trial banner shown on the Overview/Billing tabs. Copy mirrors the Register and
 * Founding pages: 7-day free trial, no credit card required, cancel anytime.
 */
export default function TrialCallout({ trial, isFounding }) {
  if (!trial) return null;

  let text;
  if (trial.status === 'pending') {
    text = (
      <>
        Your <span className={styles.trialStrong}>{/* days */}7-day free trial</span> starts
        on <span className={styles.trialStrong}>{formatDate(trial.startsAt)}</span>. No credit card
        required - you won't be charged until it ends.
      </>
    );
  } else if (trial.status === 'active') {
    text = (
      <>
        <span className={styles.trialStrong}>{trial.daysLeft} {trial.daysLeft === 1 ? 'day' : 'days'} left</span>{' '}
        on your free trial - cancel any time before {formatDate(trial.endsAt)} and you won't be billed.
      </>
    );
  } else if (trial.status === 'canceled') {
    return null; // cancellation is surfaced by the subscription card instead
  } else {
    text = <>Your free trial has ended. {isFounding ? 'Your founder pricing is locked in.' : ''}</>;
  }

  return (
    <div className={styles.trialBanner}>
      <span className={styles.trialIcon} aria-hidden="true">⚡</span>
      <span>{text}</span>
    </div>
  );
}
